import { userSchema } from "../userBase.mjs";
import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/auth/signInWithEmail.ts
const EmailSignInResult = {
	CREATED: "created",
	LOGGED_IN: "loggedIn"
};
const emailSignInResultSchema = z.enum(Object.values(EmailSignInResult));
const signInWithEmailInputSchema = z.object({
	email: z.string().email(),
	password: z.string().min(1).max(200),
	recaptchaToken: z.string().optional(),
	turnstileToken: z.string().optional()
});
const signInWithEmailOutputSchema = z.object({
	result: emailSignInResultSchema,
	user: userSchema
});
const signInWithEmailRoute = oc.route({
	method: "POST",
	path: "/sign-in/email",
	summary: "Sign in with email and password. Creates a new account when no user is registered under the submitted email."
}).input(signInWithEmailInputSchema).output(signInWithEmailOutputSchema);
//#endregion
export { EmailSignInResult, emailSignInResultSchema, signInWithEmailInputSchema, signInWithEmailOutputSchema, signInWithEmailRoute };
